export enum UserMeta {
  MODEL = "user",
  PK = "id",
}
